import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import styled, { keyframes } from "styled-components";
import { lighten } from "polished";

import { generateUniqueId } from "../../utils";

const progressBarAnimation = keyframes`
  from {
    width: 0;
  }
  to {
    width: ${(props) => props.value}%;
  }
`;

const ProgressBarWrapper = styled.div`
  display: flex;
  width: 100%;
  height: ${(props) => props.height}px;
  border-radius: 4px;
  overflow: hidden;
  background-color: #f2f3f8;
`;

const ProgressBarFill = styled.div`
  height: 100%;
  width: ${(props) => props.value}%;
  animation: ${progressBarAnimation} 1s ease-out;
  &.success {
    background: ${(props) => props.theme.green_g};
    &:hover {
      background: ${(props) => lighten(0.03, props.theme.green_g)};
    }
  }
  &.warning {
    background: ${(props) => props.theme.gold_g};
    &:hover {
      background: ${(props) => lighten(0.03, props.theme.gold_g)};
    }
  }
  &.danger {
    background: ${(props) => props.theme.red_g};
    &:hover {
      background: ${(props) => lighten(0.03, props.theme.red_g)};
    }
  }
  &.primary {
    background: ${(props) => props.theme.blue_g};
    &:hover {
      background: ${(props) => lighten(0.03, props.theme.blue_g)};
    }
  }
`;

const ProgressBar = ({ values, height }) => {
  const [bars, setBars] = useState([]);

  useEffect(() => {
    setBars(values);
  }, [values]);

  return (
    <ProgressBarWrapper height={height}>
      {bars.map(({ classNames, percentage }) => (
        <ProgressBarFill
          key={generateUniqueId()}
          className={classNames}
          value={percentage}
        />
      ))}
    </ProgressBarWrapper>
  );
};

ProgressBar.propTypes = {
  values: PropTypes.array,
  height: PropTypes.number
};

ProgressBar.defaultProps = {
  height: 8
};

export default ProgressBar;
